/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/mfa/register-totp`,
    // @ts-ignore for sm-axios
    urlTemplate: '/mfa/register-totp',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Initiates TOTP (QR code) as the MFA method for the given user.
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    /**
     * browser session JWT to identify the current user
     */
    token: string
  }
}

export interface Response {
  /**
   * TOTP secret
   */
  secret: string
  /**
   * TOTP auth URL
   */
  otpAuthUrl: string
}

